/* global angular, TweenMax, imagesLoaded */
angular.module('ua5App')
    .directive('imageLoad', [function() {
        return {
            restrict: 'A',
            link: function($scope, $element, $attrs) {
                $scope.hide = true;
                TweenMax.set($element, {
                    alpha: 0
                });
                imagesLoaded($element, function(instance) {
                    TweenMax.to($element, 0.5, {
                        alpha: 1
                    });
                });
            }
        };
    }])
;
